module.exports = __webpack_public_path__ + "img/overview_tablet@3x.3ba239c5.png";